var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rb-trust-pilot-footer" }, [
    _c(
      "div",
      { staticClass: "rb-trust-pilot-footer__widget-wrapper" },
      [
        _c("rb-trust-pilot", {
          attrs: {
            "data-template-id": _vm.templateId,
            "data-style-height": "20",
            "data-style-alignment": "center",
            target: _vm.target,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }